import { useState, useEffect } from 'react';

export const useOneMapToken = (un, pw, requiresPassword = true) => {
    // State to hold responses and loading state
    const [token, setToken] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!requiresPassword) return;
        if (!un || !pw) return;
        const h = encodeURIComponent(window.location.origin) || 'http://localhost';

        const fetchData = async () => {
            fetch(`https://onemap.cdc.gov/Portal/sharing/rest/generateToken`, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                method: 'POST',
                body: `username=${un}&password=${pw}&referer=${h}&expiration=90&f=json`
            })
                .then(async (res) => {
                    const response = await res.json();
                    setToken(response.token);

                    //Every hour res-set the token so it doens't expire
                    setTimeout(() => {
                        fetchData();
                    }, 60 * 60 * 1000);
                })
                .catch((error) => {
                    setError(error);
                    setLoading(false);
                });
        };

        fetchData(); // Call the async function
    }, [un, pw]); // Dependency array: re-run effect if endpoints change

    return { token, loading, error };
};
